<template>
  <a-layout-header
    class="header"
    :class="{ fixed: !showFooter && !showHeatmap }"
    v-if="cmsConfig && cmsConfig.navs"
  >
    <div class="header-container">
      <div class="logo" @click="refreshPage"></div>
      <div class="top-nav" v-if="hideHeaderNav"></div>
      <a-menu
        class="top-nav"
        mode="horizontal"
        theme="dark"
        :selectedKeys="selectKeys"
        @select="() => {}"
        v-else
      >
        <a-menu-item
          v-for="(nav, index) in cmsConfig.navs || []"
          :key="index + 1"
          @click="linkHandler(nav)"
          :disabled="showReportData && nav.title !== '首页' && Array.isArray(nav.children) && nav.children.length === 0"
        >
          <a-popover
            v-if="Array.isArray(nav.children) && nav.children.length > 0"
            overlayClassName='top-menu-popover'
            trigger='hover'
            placement="bottom"
            @visibleChange="handleTopSubMenuVisible"
          >
            <div>
              {{ nav.title }}
              <a-icon type="down" :rotate="rotate" />
            </div>
            <template slot="content">
              <div class="submenu-wrapper">
                <div v-for="submenu in nav.children" :key="submenu['_id']" :class="[showReportData ? 'level1-bg' : '', 'submenu-container']">
                  <a :href="submenu.url" target="_blank" :disabled="showReportData" @click="handleReport(submenu._id)">
                    <h3>{{submenu.title}}</h3>
                    <span>{{submenu.desc}}</span>
                  </a>
                  <div class="node-menu-mask" v-if="showReportData" @click.stop="showTopUser(submenu._id)">
                    <div class="click-num">{{clickNum[submenu._id] || 0}}</div>
                  </div>
                </div>

              </div>
            </template>
          </a-popover>
          <div v-else>
            {{ nav.title }}
          </div>
          <div v-if="showReportData && nav.title !== '首页' && Array.isArray(nav.children) && nav.children.length === 0" class="node-menu-mask" @click.stop="showTopUser(nav._id)">
            <div class="click-num">{{clickNum[nav._id] || 0}}</div>
          </div>
        </a-menu-item>
      </a-menu>
      <template>
        <div v-for="(item,index) in icons" :key="index">
          <!-- <a-popover overlayClassName='wx-popover' trigger='hover' placement="bottom" v-if="item.type === ICONS.WX || item.type === ICONS.PHONE" :mouseEnterDelay="showReportData ? 172800 : 0">
            <template class='wx-popover-content' slot="content">
              <div class='wx-content' v-if="item.type === ICONS.WX">
                <img :src="item.image">
                <p>{{item.text}}</p>
              </div>
              <div class="phone-show" v-else>
                <div class="phone-app" :style="{alignItems: winInfo.package_location ? '' : 'center'}">
                  <span class="title">商客合一APP</span>
                  <span class="desc">孩子王移动版商家工作台</span>
                  <div class="phone-code" :style="{borderRight: winInfo.package_location ? '1px solid #eeeeee' : ''}">
                    <div class="code-li">
                      <img class="image" src="@/assets/images/ios_code.png" alt="">
                      <span>iOS扫码下载</span>
                    </div>
                    <div class="code-li" :style="{marginRight: winInfo.package_location ? '30px' : ''}">
                      <img class="image" src="@/assets/images/android_code.png" alt="">
                      <span>Android扫码下载</span>
                    </div>
                  </div>
                </div>
                <div class="phone-yun" v-if="winInfo.package_location">
                  <span class="title">商客云台</span>
                  <span class="desc">孩子王商家工作台Win版</span>
                  <img src="@/assets/images/win.png" alt="">
                  <div class="btn" @click="goWinDownLoad">立即下载</div>
                </div>
              </div>
            </template>
            <div :class="[showReportData ? 'level1-bg' : '', 'top-icon comment']" @mouseenter="reportData(200003, item._id)">
              <img :src="item.icon" >
              <span class="title">{{item.title}}</span>
              <div v-if="showReportData" class="node-menu-mask" @click.stop="showTopUser(item._id)">
                <div class="click-num">{{clickNum[item._id] || 0}}</div>
              </div>
            </div>
          </a-popover> -->
          <div :class="[showReportData ? 'level1-bg' : '', 'top-icon comment']" v-if="item.type === ICONS.YJ" @click="goYJ(item)">
            <img :src="item.icon">
            <span class="title">{{item.title}}</span>
            <div v-if="showReportData" class="node-menu-mask" @click.stop="showTopUser(item._id)">
              <div class="click-num">{{clickNum[item._id] || 0}}</div>
            </div>
          </div>
          <!-- <div :class="[showReportData ? 'level1-bg' : '', 'top-icon']" v-else-if="item.type === ICONS.MSG && !isUggSell" @click="handleShowMsg(item)">
            <i class='msg-num-icon' v-if="!showReportData && messageCurrentDetail && messageCurrentDetail.unReadAmount">{{messageCurrentDetail.unReadAmount > 99 ? '99+' : messageCurrentDetail.unReadAmount}}</i>
            <img :src="item.icon">
            <span class="title">{{item.title}}</span>
            <div v-if="showReportData" class="node-menu-mask" @click.stop="showTopUser(item._id)">
              <div class="click-num">{{clickNum[item._id] || 0}}</div>
            </div>
          </div> -->
        </div>
      </template>
      <!--店铺下拉菜单-->
      <div :class="[showReportData ? 'level1-bg' : '', 'store-info']">
        <a-dropdown>
          <span class="dropdown-label" @mouseenter="reportData(200003, 'topbarstoreinfo')">
            {{ businessName }}<i class="logout-icon"/>
          </span>
          <a-menu slot="overlay">
            <a-menu-item v-for="(menu, index) in portalMenus" :key="index">
              <a :href="menu.url" target="_blank">{{ menu.name }}</a>
            </a-menu-item>
            <a-divider
              v-if="portalMenus && portalMenus.length > 0"
              :style="{ margin: 0 }"
            />
            <a-menu-item @click="logout">
              <a href="javascript:;">退出</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <div v-if="showReportData" class="node-menu-mask" @click.stop="showTopUser('topbarstoreinfo')">
          <div class="click-num">{{clickNum.topbarstoreinfo || 0}}</div>
        </div>
      </div>
    </div>

  </a-layout-header>
</template>

<script>
// import jsCookie from 'js-cookie'
import {
  Layout,
  Menu,
  Icon,
  Dropdown,
  Divider,
  Popover,
  Tooltip
} from "ant-design-vue";
import global from "@/mixins/global";
// import noticeList from './noticeListModal'
import { clearCookies, tracker } from "@/utils/utils";
// import QuitSvg from '@/assets/images/quit.svg'
import { mapState, mapActions } from 'vuex'

const { Item } = Menu;
const { Header } = Layout;

export default {
  name: "top-header",
  data() {
    return {
      visible: false,
      showNotice: false,
      // ICONS: { MSG: "1", YJ: "2", PHONE: "3", WX: "4" },
      ICONS: { },
      rotate: 0
      // QuitSvg,
    };
  },
  components: {
    [Header.name]: Header,
    [Menu.name]: Menu,
    [Item.name]: Item,
    [Icon.name]: Icon,
    [Dropdown.name]: Dropdown,
    [Divider.name]: Divider,
    // [suggestion.name]: suggestion,
    [Popover.name]: Popover,
    [Tooltip.name]: Tooltip,
  },
  mixins: [global],
  mounted() {
    this.getPortalMenu();
    // 获取win版版本信息
    // this.$store.dispatch('popHome/queryWin')
  },
  computed: {
    ...mapState(['messageCurrentDetail', 'isUggSell']),
    ...mapState('heatmap', ['showReportData', 'clickNum', 'jumpToken']),
    hideHeaderNav () {
      // return jsCookie.get('loginSourceCode') === 'winneropen' // 客户端版商家工作台隐藏头部菜单
      return false
    },
    showFooter() {
      return this.$store.state.showFooter;
    },
    icons() {
      const list = this.cmsConfig.topIcons || []
      return list.map(y => {return {...y, visible: false}}).filter(x => x.show)
    },
    selectKeys() {
      const hide = this.$route.query.hide === true || this.$route.query.hide === 'true'
      if (hide) {
        return []
      }
      return [1]
    }
    // businessNameNew() {
    //   return decodeURIComponent(this.$cookie.get('nickname'))
    // }
    // msgNum() {
    //   return this.$store.state.dfwHome.msgNum
    // }
  },
  watch: {
    showReportData() {
      setTimeout(() => {
        if (this.showReportData) {
          document.querySelectorAll('.top-nav > .ant-menu-item').forEach(item => {
            if (item.innerText !== '首页' && !item.querySelector('i.anticon-down')) {
              item.classList.add('level1-bg')
            }
          })
        } else {
          document.querySelectorAll('.top-nav > .ant-menu-item').forEach(item => {
            item.classList.remove('level1-bg')
          })
        }
      }, 0)
    }
  },
  methods: {
    ...mapActions('heatmap', ['getTopUser', 'getJumpToken']),
    goWinDownLoad() {
      window.open(this.winInfo.package_location)
    },
    goYJ(item) {
      this.reportData(200003, item._id)
      window.open(item.link)
    },
    toggleVisible(item, visible) {
      item.visible = visible;
    },
    handleReport (id) {
      this.reportData(200002, id)
    },
    async linkHandler (nav) {
      const { link, title, clickid, pagelevelid, _id, children, isMarketing = false } = nav
      if(clickid && pagelevelid){
        tracker(147, pagelevelid, 20000, clickid)
      }
      //强制判断首页
      if (title === '首页') {
        this.refreshPage()
      } else if (children.length > 0) {
        return
      } else if(isMarketing) {
        // 跳营销云
        await this.getJumpToken()
        if(this.jumpToken) {
          const newLink = `https://cjy-front.cekid.com/rmc-bridge/middle?redirect=${encodeURIComponent(link)}&token=${this.jumpToken}`
          const devLink = `https://cjy-rmc-bridge.cekid.com/rmc-bridge/middle?redirect=${encodeURIComponent(link)}&token=${this.jumpToken}`
          const jumpLink = process.env.VUE_APP_SEVERENV === 'BETA' ? devLink : newLink
          this.reportData(200002, _id)
          this.$openLink(jumpLink)
        }

      } else {
        // 非首页顶部菜单点击需要上报
        // 热力图统计埋点数据上报
        this.reportData(200002, _id)
        this.$openLink(link)
        clearCookies([ 'history_url', 'history_selectedKeys', 'history_openKeys', 'history_currentComponent' ])
      }
    },
    handleShowMsg(item) {
      this.reportData(200003, item._id)
      this.showNotice = true
    },
    handleChangeMessage(visible) {
      this.showNotice = visible
    },
    appClickHandler (link) {
      if (link && link !== '') {
        this.$openLink(link)
      }
    },
    commentClickHandler(field) {
      this[field] = true
    },
    cancelHandler() {
      this.visible = false
      this.showNotice = false
    },
    refreshPage () {
      clearCookies([ 'history_url', 'history_selectedKeys', 'history_openKeys', 'history_currentComponent' ])
      location.href = '/platform/ly'
      // window.location.reload()
    },
    reportData (clickid, path) {
      const { buzzType } = this.userInfo
      // 热力图统计埋点数据上报
      if (buzzType === 1 || buzzType === 2) {
        // pop
        tracker(116, 121013119, 20000, clickid, {path})
      } else if (buzzType === 3) {
        // 品牌商
        tracker(116, 121013121, 20000, clickid, {path})
      } else if (buzzType === 4) {
        // 供应商
        tracker(116, 121013122, 20000, clickid, {path})
      }
    },
    showTopUser(menuKey) {
      this.getTopUser({menuKey})
    },
    handleTopSubMenuVisible(visible) {
      if(visible) {
        this.rotate = 180
      } else {
        this.rotate = 0
      }
    }
  }
};
</script>

<style lang="scss">
.wx-popover{
  .ant-popover-inner-content{
    padding: 20px;
  }
  .wx-content{
    width: 120px;
    // display: flex;
    text-align: center;

    img {
      width: 120px;
      height: 120px;
    }
    p {
      padding-top: 6px;
      padding-left: 15px;
      padding-right: 15px;
      color: #666;
      font-size: 12px;
    }
  }
  .phone-show {
    display: flex;
    .phone-yun {
      display: flex;
      flex-direction: column;
      margin-left: 23px;
      .title {
        font-family: PingFangSC-Medium;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        line-height: 22px;
        margin-bottom: 5px;
      }
      .desc {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        margin-bottom: 15px;
      }
      img {
        width: 76px;
        height: 76px;
        margin-bottom: 17px;
      }
      .btn {
        width: 72px;
        height: 24px;
        background: #1C7AE5;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 22px;
        cursor: pointer;
      }
    }
    .phone-app {
      display: flex;
      flex-direction: column;
      .title {
        font-family: PingFangSC-Medium;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        line-height: 22px;
        margin-bottom: 5px;
      }
      .desc {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        margin-bottom: 15px;
      }
      .phone-code {
        display: flex;
        .code-li {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #666666;
          letter-spacing: 0;
          .image {
            width: 90px;
            height: 90px;
            flex-shrink: 0;
            margin-bottom: 15px;
          }
        }
        .code-li:first-child{
          margin-right: 30px;
        }
      }
    }
  }
}
.top-menu-popover {
  width: 100vw;
  min-width: 1366px;
  padding-top: 0;
  .ant-popover-arrow {
    display: none !important;
  }
  .ant-popover-content {
    position: relative;
    top: -4px;
  }
  .ant-popover-inner-content {
    display: flex;
    justify-content: center;
  }
  .submenu-wrapper {
    width: 100%;
    padding: 0 200px;
    display: flex;
    flex-wrap: wrap;
    .submenu-container {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 240px;
      height: 68px;
      padding: 14px 16px;
      margin-right: 16px;
      cursor: pointer;
      &:hover {
        background: #F8FAFC;
        border-radius: 2px;
        h3 {
          color: #1066CC;
        }
      }
      h3 {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 18px;
        margin-bottom: 6px;
      }
      span {
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .node-menu-mask .click-num {
        top: 0;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
$bg-color: #1066cc;
.header {
  // position: fixed;
  // z-index: 1;
  width: 100%;
  min-width: 1366px;
  line-height: 60px;
  height: 60px;
  // top:0;
  background: $bg-color;
  padding-left: 20px;
  padding-right: 0;
  display: flex;
  flex-wrap: nowrap;
  /* justify-content: center; */

  &.fixed {
    position: fixed;
    z-index: 1;
    top: 0;
  }
  .header-container {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
  }
  .logo {
    // width: 120px;
    // height: 32px;
    width: 144px;
    height: 48px;
    background: url("https://hzwimspic-1251601690.image.myqcloud.com/1/75bd8d30-6816-11ee-9553-39df169a315a_size_144x48")
      center center;
    background-size: 100% 100%;
    margin: 6px 20px;
    margin-right: 54px;

    &:hover {
      cursor: pointer;
    }
  }
  .top-nav {
    flex: 1;
    background-color: $bg-color;
    height: 60px;
    line-height: 60px;
    overflow: hidden;
    position: relative;

    .ant-menu-item {
      line-height: 60px;
      color: #fff;
      margin-right: 10px;
    }
    .ant-menu-item-selected {
      background-color: transparent;
    }
    .ant-menu-item-selected::after {
      position: absolute;
      content: "";
      height: 60px;
      width: 100%;
      left: 0;
      top: 0;
      opacity: 0.3;
      background-image: linear-gradient(
        0deg,
        #ffffff 0%,
        rgba(255, 255, 255, 0) 100%
      );
      // background-image: linear-gradient(0deg, rgba(255,255,255,.3) 0%, rgba(255,255,255,0) 80%);
    }
  }
  .top-icon {
    // width: 48px;
    // line-height: 60px;
    position: relative;
    text-align: center;
    padding: 0 12px;
    margin-left: 7px;
    height: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:hover {
      cursor: pointer;
    }
    img {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
    }
    .title {
      line-height: 25px;
      font-size: 12px;
      color: #FFFFFF;
    }
    .msg-num-icon{
      color: #FFFFFF;
      background: #FF3232;
      border-radius: 7px;
      border-radius: 7px;
      min-width: 14px;
      padding: 0 5px 0 4px;
      height: 14px;
      margin-left: 4px;
      line-height: 14px;
      text-align: center;
      position: absolute;
      top: 4px;
      left: 21px;
      font-size: 12px;
    }
  }

  .store-info {
    display: flex;
    position: relative;
    align-items: ceil($number: 0);
    // min-width: 100px;
    font-size: 14px;
    text-align: right;
    // float: right;
    color: #ffffff;
    margin-left: 7px;
    padding-left: 28px;
    padding-right: 28px;
    .icon {
      margin-left: 4px;
    }
    .close {
      display: inline-block;
      margin-left: 3px;
      width: 12px;
      height: 12px;
      background: url("https://cmspic-10004025.image.myqcloud.com/f40f4a50-14cf-11ea-8218-03544d57eeb0_size_24x24")
        center center;
      background-size: 100%;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .dropdown-label {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .logout-icon {
    width: 14px;
    height: 14px;
    margin-left: 4px;
    background-image: url("../../../assets/images/quit.png");
    background-repeat: no-repeat;
    background-size: 100%;
    display: inline-block;
  }
}
.store-menu {
  color: rgba(0, 0, 0, 0.65);
  width: 60px;
  .item {
    display: block;
    &:hover {
      cursor: pointer;
    }
  }
}
.node-menu-mask {
  border-radius: 4px;
  height: 60px;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
  text-align: right;
  .click-num {
    border-radius: 4px;
    color: #f7f7f7;
    font-weight: 500;
    height: 20px;
    line-height: 20px;
    position: relative;
    top: -20px;
    padding: 0 6px;
    display: inline-block;
    background: #ff2d2d;
  }
}
.level1-bg {
  color: #FFD5D5 !important;
  background: rgba(255,117,116,0.3) !important;
  &.top-icon {
    .title {
      color: #FFD5D5 !important;
    }
  }
}

</style>
<style lang="scss">
.store-tooltip {
  .ant-tooltip-arrow {
    border-bottom-color: #ffffff;
  }
  .ant-tooltip-inner {
    background-color: #ffffff;
  }
}
</style>
